import { motion } from "framer-motion";
import {
  HardHat, House, Wind, PaintRoller, Barricade, Bathtub, Buildings, Cube, GridFour, Wrench, ArrowUpRight,
} from "@phosphor-icons/react";
import Reveal from "@/components/site/Reveal";
import { SERVICES } from "@/lib/siteData";

const ICONS = { HardHat, House, Wind, PaintRoller, Barricade, Bathtub, Buildings, Cube, GridFour, Wrench };

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 lg:py-32 bg-surface border-y border-line">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">What We Do</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading font-bold tracking-tight text-white text-4xl sm:text-6xl leading-[1]">
              Our Services
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-white/70 max-w-xl">
              From everyday repairs to larger improvement projects, B3 Contracting can help.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.a
                href={`/services/${s.slug}`}
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className={`group relative bg-surface p-8 lg:p-10 hover:bg-ink transition-colors duration-300 ${
                  s.featured ? "md:col-span-2" : ""
                }`}
              >
                <div className="flex items-start justify-between">
                  <Icon size={40} weight="duotone" className="text-gold" />
                  <ArrowUpRight
                    size={20}
                    weight="bold"
                    className="text-white/20 transition-all duration-300 group-hover:text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </div>
                <h3 className="mt-8 font-heading font-semibold text-white text-xl tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm text-white/60 leading-relaxed max-w-md">{s.desc}</p>
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gold transition-all duration-300 group-hover:w-full" />
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
